module.exports = __webpack_public_path__ + "img/abdirashid.1ace581a.jpg";